/* eslint-disable */
import VueAppInsights from 'vue-application-insights';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import OktaVue from '@okta/okta-vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import './plugins/base';
import './plugins/chartist';
import './plugins/vee-validate';
import './plugins/vue-world-map';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import oktaAuthRef from './auth/okta';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(OktaVue, { oktaAuth: oktaAuthRef })
Vue.use(VueAppInsights, {
  id: `${process.env.VUE_APP_AZURE_APPLICATION_INSIGHTS_KEY}`,
  router,
  trackInitialPageView: true
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')


Vue.extend({

  methods: {
    custom_action() {
      this.$appInsights.trackEvent({
        name: 'custom_action',
        properties: { value: 'ok' }
      });
    }
  }
});
